import { get } from "lodash";
import { Children } from "react";
import { memo } from "utils/memo";
import { TableRow, TableHead, TableCell, Typography } from "@mui/material";

const EditBankingTableHeader = ({ columns = [] }: { columns: any[] }) => {
  return (
    <TableHead>
      <TableRow>
        {
          <TableCell
            align="center"
            sx={{
              border: "none",
              textTransform: "capitalize",
              padding: 1,
            }}
          ></TableCell>
        }
        {Children.toArray(
          columns.map((column: any) => {
            return (
              <TableCell
                key={column.label}
                align={get(column, "align", "")}
                sx={{
                  border: "none",
                  textTransform: "capitalize",
                  padding: 1,
                }}
              >
                <Typography
                  variant="body1"
                  fontSize={14}
                  noWrap
                  fontWeight={600}
                >
                  {column.label}
                </Typography>
              </TableCell>
            );
          })
        )}
      </TableRow>
    </TableHead>
  );
};

export default memo(EditBankingTableHeader);
